export default "__VITE_ASSET__cbbd90f3__"